import get from 'lodash-es/get';

const nativeEvents = [
  'abort',
  'canplay',
  'canplaythrough',
  'durationchange',
  'emptied',
  'ended',
  'error',
  'loadeddata',
  'loadedmetadata',
  'loadstart',
  'pause',
  'play',
  'playing',
  'progress',
  'ratechange',
  'seeked',
  'seeking',
  'stalled',
  'suspend',
  'timeupdate',
  'volumechange',
  'waiting'
];


export default class VideoAPI {

  constructor(host, optionsPath, el) {
    this._video = el;
    this._host = host;    
    nativeEvents.forEach((event) => {
      this._video.addEventListener(event, (e) => { 
        host.fire(`video${event.charAt(0).toUpperCase() + event.slice(1)}`, this._host, {event: e, video: this});
      });
    });

    host.on('destroy', () => {
      if(this._video){
        this.stop();
        this._video.remove();                             
        delete this._video;
        delete this._host;
      }
    });

    host.once('init', () => {
      this.applyOptions(get(host,optionsPath));
    });

    host.on('init', () => {
      if(this.getAutoplay() == 'onComponentReload'){
        this.play();
      }
    });
  }

  setCameraPreview(cameraPreview){
    if(this._cameraPreview!==cameraPreview){
      this._cameraPreview=cameraPreview;
      // if(cameraPreview&&this.getAutoplay()!=='off'){
      //   this.play();        
      // }else{
      //   if(this._stream){
      //     this._stream.getTracks().forEach(track => track.stop());
      //     delete this._stream;
      //     delete this._recorderPromise;
      //   }
      // }
    }
  }

  getUrl(){
    return this._url;
  }

  setUrl(url){
    if(this._url!==url){
      this._url=url;

      if(url){
        if(url.toLowerCase().startsWith('dropbox://')){
          const dburl = url.substring(10);
          const lastSlashIndex = dburl.lastIndexOf('/');
          let path = dburl.substring(0, lastSlashIndex);
          const name = dburl.substring(lastSlashIndex + 1);     
          url = this._host.dropBoxGetFileUrl({path,name});
        }     
      }else{
        url='';
      }

      this._video.src = url;
      this._host.fire('videoUrlChange', this._host, {url, video: this});
      if(this.getAutoplay() == 'onUrlChange'){
        this.play();
      }     
    }
  }

  applyOptions(options={}){

    if(!this._options || this._options.loop!==options.loop){
      this.setLoop(options.loop||false);
    }

    if(!this._options || this._options.volume!==options.volume){
      this.setVolume(options.volume||1);
    }

    if(!this._options || this._options.muted!==options.muted){
      this.setMuted(options.muted||false);
    }

    if(!this._options || this._options.currentTime!==options.currentTime){
      this.setCurrentTime(options.currentTime||0);
    }

    if(!this._options || this._options.autoplay!==options.autoplay){
      this.setAutoplay(options.autoplay);
    }

    if(!this._options || this._options.cameraPreview!==options.cameraPreview){
      this.setCameraPreview(options.cameraPreview);
    }

    if(!options.cameraPreview&&(!this._options || this._options.url!==options.url)){
      this.setUrl(options.url);
    }

    if(!this._options || this._options.hideControls!==options.hideControls){
     this.setControls(!options.hideControls);
    }

    this._options = options;
    this._host.fire('videoOptionsChange', this._host, {options, video: this});
  }

  takeSnapshot(){
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.setAttribute('width', this._video.videoWidth);
    canvas.setAttribute('height', this._video.videoHeight);
    context.drawImage(this._video, 0, 0, this._video.videoWidth, this._video.videoHeight);
    const image = canvas.toDataURL('image/png');
    this._host.fire('videoSnapshot', this._host, {image, video: this});
    canvas.remove();
  }

  play(){
    if(this._cameraPreview){     


      navigator.mediaDevices
      .getUserMedia({audio:false,video:{
        width: { ideal: this._video.clientWidth },
        height: { ideal: this._video.clientHeight },
      }})
      .then((stream) => {
        this._video.srcObject = stream;
        this._stream = stream;
        this._video.play();
      });        
    }else{
      this._video.play();      
    }

  }

  pause(){
    this._video.pause();
  }

  stop(){
    this._video.pause();
    this._video.currentTime = 0;

    if(this._cameraPreview){
      if(this._stream){
        this._stream.getTracks().forEach(track => track.stop());
        delete this._stream;
        delete this._recorderPromise;
      }
    }

  }

  setVolume(volume){
    this._video.volume = volume;
  }

  getVolume(){
    return this._video.volume;
  }

  setMuted(muted){
    this._video.muted = muted;
  }

  isMuted(){
    return this._video.muted;
  }

  setLoop(loop){
    this._video.loop = loop;
  }

  isLoop(){
    return this._video.loop;
  }

  setCurrentTime(time){
    this._video.currentTime = time;
  }

  getCurrentTime(){
    return this._video.currentTime;
  }

  getDuration(){
    return this._video.duration;
  }

  isPaused(){
    return this._video.paused;
  }

  isEnded(){
    return this._video.ended;
  }

  isBuffered(){
    return this._video.buffered;
  }

  isSeekable(){
    return this._video.seekable;
  }

  isPlayed(){
    return this._video.played;
  }

  getReadyState(){
    return this._video.readyState;
  }

  getNetworkState(){
    return this._video.networkState;
  }

  isSeeking(){
    return this._video.seeking;
  }

  getError(){
    return this._video.error;
  }

  setAutoplay(autoplay){
    this._autoplay = autoplay;
    this._host.fire('videoAutoplayChange', this._host, {autoplay, video: this});
  }

  getAutoplay(){
    return this._autoplay;
  }

  setControls(controls){
    this._video.controls = controls;
    this._host.fire('videoControlsChange', this._host, {controls, video: this});
  }

  getControls(){
    return this._video.controls;
  }
}